
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-edit",
  "use": "icon-material-edit-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-edit\"><path d=\"M181.91-182.15h44.24l459.81-458.81-43.76-44-460.29 459.05zm-67.89 68.13V-253.5l574.52-573.76q8.24-8.48 19.81-13.22 11.56-4.74 24.11-4.74 11.47 0 22.95 4.74t21.2 12.98l51.89 51.17q9.24 9.72 13.48 21.32t4.24 23.31q0 11.72-4.74 23.7t-12.98 20.46L253.74-114.02zM775.17-732.7l-41.24-41.47zM664.2-663.2l-22-21.76 43.76 44z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-edit"/>
                </svg>
            );
        };

        Icon.id = "icon-material-edit";

        export default Icon;
    